// Posting — pure helpers.
export const PO_USER = { name: 'Ava Thompson', org: 'Lone Star Billing' } as const;
export { PMS } from '@/features/shared/pms';
export const TODAY_ISO = '2026-10-18';

export const PO_ACTOR = { name: 'Ava Thompson', org: 'Lone Star Billing' } as const;

/** $1,180.00 — always two decimals, grouped. */
export function money(n: number): string {
  return `$${Math.abs(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

/** $2,422 — no decimals, grouped (header/tab totals). */
export function wholeMoney(n: number): string {
  return `$${Math.round(Math.abs(n)).toLocaleString('en-US')}`;
}

/** Signed money with a real minus sign: −$28.00 / +$4.18 / $486.00. */
export function signedMoney(n: number, opts?: { plus?: boolean }): string {
  if (n < 0) return `−${money(n)}`;
  if (n > 0 && (opts?.plus ?? false)) return `+${money(n)}`;
  return money(n);
}

/** aria text for a signed amount. */
export function amountAria(n: number): string {
  const abs = money(n).replace('$', '');
  if (n < 0) return `minus ${abs} dollars`;
  return `${abs} dollars`;
}

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

function parse(iso: string): Date | null {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  if (!m) return null;
  return new Date(Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3])));
}

export function formatShort(iso: string): string {
  const d = parse(iso);
  if (!d) return iso;
  return `${MONTHS[d.getUTCMonth()] ?? ''} ${String(d.getUTCDate())}`;
}

/** Whole days from an ISO date to today. */
export function daysAgo(iso: string, fromIso: string = TODAY_ISO): number {
  const a = parse(iso);
  const b = parse(fromIso);
  if (!a || !b) return 0;
  return Math.round((b.getTime() - a.getTime()) / 86_400_000);
}

/** How a card payment reads in Posted. Never "Matched": card payments settle outside the bank statements (D195). */
export function cardChargedLine(approval: string): string {
  return `Charged · approval ${approval} · settlement not checked`;
}
